
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface FacilityTheme {
  primary: string;
  secondary: string;

}

interface FacilityConfig {
  id: number;
  name: string;
  theme: FacilityTheme;
  phoneNumber?: string;
  address?: string;
}

const facilityConfigs: Record<number, FacilityConfig> = {
  5: {
    id: 5,
    name: "Hemen MCH Center",
    theme: {
      primary: "#8A52A1",
      secondary: "#B485BA",
    },
  },
};

const defaultFacilityConfig: FacilityConfig = {
  id: 0,
  name: "PrimeChart",
  theme: {
    primary: "#0ea5e9", 
    secondary: "#60A5FA", 
  
  },
};

interface FacilityState {
  currentFacility: FacilityConfig;
  setCurrentFacility: (facilityId: number) => void;
}

export const useFacilityStore = create<FacilityState>()(
  persist(
    (set) => ({
      currentFacility: defaultFacilityConfig,
      setCurrentFacility: (facilityId: number) =>
        set({
          currentFacility: facilityConfigs[facilityId] || defaultFacilityConfig,
        }),
    }),
    {
      name: "facility-store",
    }
  )
);
